/**
 * Chart colors for the Allo inline charts (SD-2674) — the single source of
 * truth. chart.js paints onto a canvas, so CSS custom properties can't theme
 * these; the chart card picks a palette from the theme-management store and
 * rebuilds its chart when the theme flips.
 */
export interface ChartPalette {
  /** One color per category; indexes past the end wrap around. */
  categorical: string[];
  /** Two-tone pairing for period-over-period comparisons. */
  duo: string[];
  grid: string;
  text: string;
}

export const CHART_PALETTE_LIGHT: ChartPalette = {
  categorical: [
    '#1c2a3a',
    '#f9423a',
    '#3f8f6b',
    '#4f7fd0',
    '#d9a13a',
    '#7c5cc4',
    '#5b6166',
    '#a7a392',
    '#2c4a52',
    '#c0563f',
  ],
  duo: ['#1c2a3a', '#f9423a'],
  grid: '#e8e5de',
  text: '#1f2937',
};

/** Brightened for contrast on the dark surface; the Poppy accent is kept exact. */
export const CHART_PALETTE_DARK: ChartPalette = {
  categorical: [
    '#7f9bb8',
    '#f9423a',
    '#5fbf92',
    '#7aa5e8',
    '#e8bc63',
    '#a189dd',
    '#9aa1a7',
    '#c4c0ad',
    '#6fa0ab',
    '#dc8168',
  ],
  duo: ['#7f9bb8', '#f9423a'],
  grid: '#464643',
  text: '#fafafa',
};
